
export function isLangEnglish() {
    let language = localStorage.getItem('healthcare_lang');
    if(language){
        if(language == 'en'){
            return true
        }else{
            return false
        }
    }else{
        return true
    }
}